// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Backdrop_backdrop__2BM53","hidden":"Backdrop_hidden__1uORw"};